module.exports = __webpack_public_path__ + "img/main_ani_2.3358628c.png";